/* eslint-disable @typescript-eslint/no-explicit-any */
import { createStore } from 'idb-keyval';

const DB_NAME = 'cx_operation_system';

/**
 * 强制创建数据库 + 所有需要的表
 * 初始化时调用一次即可
 */
export async function initIndexedDB(): Promise<void> {
    return new Promise((resolve, reject) => {
        if (!window.indexedDB) {
            reject(new Error('浏览器不支持 IndexedDB'));
            return;
        }

        const request = window.indexedDB.open(DB_NAME);

        // 数据库第一次创建 / 版本升级时触发
        request.onupgradeneeded = (e) => {
            const db = (e.target as IDBOpenDBRequest).result;

            // ✅ 创建 param-store
            if (!db.objectStoreNames.contains('param-store')) {
                db.createObjectStore('param-store');
                console.log('✅ 表创建：param-store');
            }

            // ✅ 创建 columns-store
            if (!db.objectStoreNames.contains('columns-store')) {
                db.createObjectStore('columns-store');
                console.log('✅ 表创建：columns-store');
            }

            // ✅ 创建 screen-store
            if (!db.objectStoreNames.contains('screen-store')) {
                db.createObjectStore('screen-store');
                console.log('✅ 表创建：screen-store');
            }

            // ✅ 创建 temporary-store
            if (!db.objectStoreNames.contains('temporary-store')) {
                db.createObjectStore('temporary-store');
                console.log('✅ 表创建：temporary-store');
            }
        };

        request.onsuccess = () => {
            request.result.close();
            resolve();
        };

        request.onerror = () => {
            reject(request.error);
        };
    });
}

/**
 * 获取指定表的操作实例
 * @param storeName
 */
export function getDB(storeName: string) {
    const store = createStore(DB_NAME, storeName);

    return {
        async setItem(key: string, value: any) {
            return await import('idb-keyval').then((m) =>
                m.set(key, JSON.stringify(value), store)
            );
        },
        async getItem(key: string) {
            try {
                const val = await import('idb-keyval').then((m) => m.get(key, store));
                return val ? JSON.parse(val) : null;
            } catch {
                return null;
            }
        },
        async removeItem(key: string) {
            return await import('idb-keyval').then((m) => m.del(key, store));
        },
        async clearAll() {
            return await import('idb-keyval').then((m) => m.clear(store));
        },
    };
}

// 导出两个常用表实例
export const paramDB = getDB('param-store');
export const columnsDB = getDB('columns-store');
export const screenDB = getDB('screen-store');

export const temporaryDB = getDB('temporary-store');